<template>
  <div class="ui main container">
    <h2>Carrito</h2>
    <div class="ui one column stackable grid">
      <div class="row">
        <div class="column">
          <h3 class="ui dividing header">
            Productos en el carrito
          </h3>
          <div class="ui clearing top attached segment">
            <div class="ui left floated header">
              <sui-button @click="goHome">
                Atras
              </sui-button>
            </div>
            <div
              v-if="getCart.products.length > 0"
              class="ui right floated header"
            >
              <div class="ui left labeled button" tabindex="0">
                <a class="ui basic label">
                  {{ total | numeralFormat('$0,0.00') }}
                </a>
                <div
                  class="ui icon positive button"
                  @click="checkout"
                  v-if="total > 0"
                >
                  <i class="shopping cart icon"></i>
                  Pasar a la caja
                </div>
              </div>
            </div>
          </div>
          <div v-if="getCart.products.length > 0" class="ui attached segment">
            <div class="ui divided unstackable items">
              <ProductDetails
                v-for="product in getCart.products"
                :key="product.attributeId"
                :product="product"
                :show-buttons="true"
                :isWholesale="isWholesale"
                :isSlave="isSlave"
                @updateQuantity="openUpdate"
                @removeProduct="openRemoveDialog"
              />
            </div>
          </div>
          <div v-else class="ui segment">
            <h3>Aún no tienes productos en el carrito</h3>
          </div>
        </div>
      </div>
    </div>
    <sui-modal v-model="open">
      <sui-modal-header>Actualizar cantidad</sui-modal-header>
      <sui-modal-content image>
        <sui-modal-description>
          <div class="ui form">
            <h3>{{ name }}</h3>
            <table class="ui very basic compact table unstackable">
              <thead>
                <tr>
                  <th class="one wide" scope="col">Existencias</th>
                  <th class="one wide" scope="col">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="one wide">
                    {{ maxQuantity }}
                  </td>
                  <td class="two wide">
                    <vue-numeric-input
                      v-model="tmpQuantity"
                      :min="0"
                      :max="maxQuantity"
                      :step="1"
                      size="100px"
                      align="center"
                    ></vue-numeric-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button @click="closeModal" negative>
          Cancelar
        </sui-button>
        <sui-button @click="updateQuantity" positive>
          Aceptar
        </sui-button>
      </sui-modal-actions>
    </sui-modal>
    <sui-modal v-model="openRemove" size="mini">
      <sui-modal-header
        >¿Desea eliminar el producto del carrito?</sui-modal-header
      >
      <sui-modal-content>
        <sui-modal-description>
          <sui-header>{{ currentQuantity }} Pieza(s) - {{ name }} </sui-header>
          <p>
            <b></b>
          </p>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button @click="closeRemove" negative>
          Cancelar
        </sui-button>
        <sui-button positive @click="remove">
          Aceptar
        </sui-button>
      </sui-modal-actions>
    </sui-modal>
  </div>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';
import ProductDetails from '../components/product/ProductDetails';

export default {
  name: 'Cart',
  data: function() {
    return {
      open: false,
      openRemove: false,
      name: '',
      maxQuantity: 0,
      currentQuantity: 0,
      tmpQuantity: 0
    };
  },
  created: function() {
    this.$store.dispatch('cart/load');
  },
  computed: {
    getCart: function() {
      return this.$store.getters['cart/getCart'];
    },
    total: function() {
      return this.$store.getters['cart/total'];
    },
    totalItems: function() {
      return this.$store.getters['cart/totalItems'];
    },
    wholesaleQty: function() {
      return this.$store.getters['application/getWholeSaleQty'];
    },
    isWholesaleEnabled: function() {
      return this.$store.getters['application/isWholesaleEnabled'];
    },
    isSlave: function() {
      return this.$store.getters['application/isSlave'];
    },
    isWholesale: function() {
      if (this.isWholesaleEnabled) {
        return this.totalItems >= this.wholesaleQty;
      } else {
        return false;
      }
    }
  },
  methods: {
    openUpdate: async function(product) {
      const stocks = await this.$store.dispatch(
        'products/getStock',
        product.productId
      );
      const stock = stocks.find(s => s._id === product._id);

      this.maxQuantity = stock.stock + product.quantity;
      this.tmpQuantity = product.quantity;
      this.currentQuantity = product.quantity;
      this.name = product.name;
      this.attributeId = product._id;
      this.productId = product.productId;
      this.open = !this.open;
    },

    closeModal: function() {
      this.open = !this.open;
    },

    updateQuantity: async function() {
      if (this.currentQuantity !== this.tmpQuantity) {
        if (Number.isInteger(this.tmpQuantity)) {
          const payload = {
            attributeId: this.attributeId,
            newQuantity: this.tmpQuantity,
            productId: this.productId
          };

          const resp = await this.$store.dispatch(
            'cart/updateQuantity',
            payload
          );
        } else {
          console.log('new quantity is not a number');
        }
      }
      this.open = !this.open;
    },
    openRemoveDialog: function(product) {
      this.name = product.name;
      this.attributeId = product._id;
      this.productId = product.productId;
      this.currentQuantity = product.quantity;
      this.openRemove = !this.openRemove;
    },
    remove: async function() {
      const payload = {
        attributeId: this.attributeId,
        newQuantity: 0,
        productId: this.productId
      };

      const resp = await this.$store.dispatch('cart/updateQuantity', payload);
      this.openRemove = !this.openRemove;
    },
    closeRemove: function() {
      this.openRemove = !this.openRemove;
    },
    checkout: function() {
      this.$router.push({ name: 'Checkout' });
    },
    goHome: function() {
      this.$router.push({ name: 'Home' });
    }
  },
  components: {
    ProductDetails,
    VueNumericInput
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.main.container {
  margin-top: 7em;
}
</style>
